var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex: auto;\n\n  ul {\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: flex-end;\n  }\n\n  li {\n    @media screen and (max-width: 1024px) {\n      display: none;\n    }\n\n    margin: 0;\n    list-style: none;\n\n    a {\n      color: ', ';\n      font-size: 15px;\n      display: block;\n      margin: 0.5rem 1rem;\n      border-top: solid 2px transparent;\n      text-decoration: none !important;\n\n      &:hover {\n        color: ', ';\n        border-top: solid 2px ', ';\n        text-decoration: none;\n      }\n\n      &:hover:before {\n        background-color: transparent;\n      }\n\n      &:focus {\n        text-decoration: none;\n        color: ', ';\n      }\n    }\n\n    button {\n      margin-right: 0.75rem;\n    }\n  }\n'], ['\n  display: flex;\n  flex: auto;\n\n  ul {\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: flex-end;\n  }\n\n  li {\n    @media screen and (max-width: 1024px) {\n      display: none;\n    }\n\n    margin: 0;\n    list-style: none;\n\n    a {\n      color: ', ';\n      font-size: 15px;\n      display: block;\n      margin: 0.5rem 1rem;\n      border-top: solid 2px transparent;\n      text-decoration: none !important;\n\n      &:hover {\n        color: ', ';\n        border-top: solid 2px ', ';\n        text-decoration: none;\n      }\n\n      &:hover:before {\n        background-color: transparent;\n      }\n\n      &:focus {\n        text-decoration: none;\n        color: ', ';\n      }\n    }\n\n    button {\n      margin-right: 0.75rem;\n    }\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled, { withTheme } from 'styled-components';
import LoginButton from '../LoginButton';
import LogoutButton from '../LogoutButton';
import Constants from '../../../../themes/rml';
import theme from '../../../../themes/rml';
import { GhostButton } from '../../../StyledComponents/Button';
var Container = styled.nav(_templateObject, Constants.colours.neutral.darkest, Constants.colours.primary.base, Constants.colours.primary.base, Constants.colours.primary.base);

var Items = function Items(_ref) {
  var buttons = _ref.buttons,
      websiteDomain = _ref.websiteDomain,
      groupDomain = _ref.groupDomain;
  return buttons || getDefaultMenuItems({
    groupDomain: groupDomain,
    websiteDomain: websiteDomain
  });
};

export var getDefaultMenuItems = function getDefaultMenuItems(_ref2) {
  var groupDomain = _ref2.groupDomain,
      websiteDomain = _ref2.websiteDomain;
  return Constants.defaultMenuItems.map(function (link) {
    // The default menu items have a mixture between group and micro site links
    var href = link.site === 'group' ? '' + groupDomain + link.href : '' + websiteDomain + link.href;
    return React.createElement('li', {
      key: link.href,
      className: link.className
    }, link.type === 'button' ? React.createElement(GhostButton, {
      onClick: function onClick() {
        return window.location = link.href;
      },
      customSize: true,
      size: theme.header && theme.header.fontSize || 'normal'
    }, link.text) : React.createElement('a', {
      href: href
    }, link.text));
  });
};

var HorizontalMenuItems = function HorizontalMenuItems(_ref3) {
  var buttons = _ref3.buttons,
      burger = _ref3.burger,
      onLogin = _ref3.onLogin,
      logout = _ref3.logout,
      _ref3$login = _ref3.login,
      login = _ref3$login === undefined ? {
    showButton: true
  } : _ref3$login,
      websiteDomain = _ref3.websiteDomain,
      groupDomain = _ref3.groupDomain,
      _ref3$isLoggedIn = _ref3.isLoggedIn,
      isLoggedIn = _ref3$isLoggedIn === undefined ? false : _ref3$isLoggedIn;
  return React.createElement(Container, {
    className: 'horizontal-nav'
  }, React.createElement('ul', null, React.createElement(Items, {
    buttons: buttons,
    websiteDomain: websiteDomain,
    groupDomain: groupDomain
  })), React.createElement('div', null, isLoggedIn && logout && React.createElement(LogoutButton, {
    logout: logout
  }), !isLoggedIn && login.showButton !== false && React.createElement(LoginButton, {
    onClick: onLogin
  })), burger);
};

export default withTheme(HorizontalMenuItems);